import React from 'react';

export const ButtonSend = () => {
    return (
        <button className="btn btn-primary" type="submit" data-kt-element="send">
            Enviar
        </button>
    );
};
